﻿/* Keep Shopify's selected order within each stock group, across every page. */
(function () {
  'use strict';

  function stockFirst(cards) {
    return cards.filter(card => card.dataset.available !== 'false')
      .concat(cards.filter(card => card.dataset.available === 'false'));
  }

  async function collectPages(pageCount, currentPage, currentCards, fetchPage) {
    const pages = new Array(pageCount);
    pages[currentPage - 1] = currentCards;
    let next = 1;
    async function worker() {
      while (next <= pageCount) {
        const page = next++;
        if (page !== currentPage) pages[page - 1] = await fetchPage(page);
      }
    }
    await Promise.all(Array.from({ length: Math.min(3, pageCount) }, worker));
    return stockFirst(pages.flat());
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { stockFirst, collectPages };
    return;
  }
  const root = document.querySelector('[data-collection]');
  if (!root) return;
  const form = root.querySelector('[data-collection-form]');
  const close = () => document.body.classList.remove('filters-open');
  root.querySelectorAll('[data-filters-toggle]').forEach(button => button.addEventListener('click', () => document.body.classList.add('filters-open')));
  root.querySelectorAll('[data-filters-close]').forEach(button => button.addEventListener('click', close));
  document.querySelector('[data-filters-overlay]')?.addEventListener('click', close);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
  root.querySelector('[data-sort]')?.addEventListener('change', () => {
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });
  form?.addEventListener('submit', () => {
    form.querySelectorAll('input[type="number"]').forEach(input => { input.disabled = input.value.trim() === ''; });
    close();
  });

  const grid = root.querySelector('[data-products-grid]');
  if (!grid) return;
  const pageCount = Number(grid.dataset.pages);
  let currentPage = Number(grid.dataset.page);
  const pageSize = Number(grid.dataset.pageSize);
  const more = root.querySelector('[data-pagination]');
  const button = more?.querySelector('[data-load-more]');
  const buttonLabel = button?.textContent;
  let orderedCards;
  let pending;
  let observer;
  let loading = false;

  async function fetchPage(page) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', page);
    url.searchParams.set('section_id', grid.dataset.sectionId);
    const response = await fetch(url, { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('Unable to load collection');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fetchedGrid = doc.querySelector('[data-products-grid]');
    if (!fetchedGrid || Number(fetchedGrid.dataset.pages) !== pageCount || Number(fetchedGrid.dataset.page) !== page) {
      throw new Error('Collection changed; reload to retry');
    }
    return Array.from(fetchedGrid.children);
  }

  function ensureOrder() {
    if (!pending) {
      grid.setAttribute('aria-busy', 'true');
      pending = collectPages(pageCount, currentPage, Array.from(grid.children), fetchPage)
        .then(cards => {
          orderedCards = cards;
          grid.replaceChildren(...cards.slice((currentPage - 1) * pageSize, currentPage * pageSize));
        })
        .catch(error => { pending = null; throw error; })
        .finally(() => grid.removeAttribute('aria-busy'));
    }
    return pending;
  }

  async function loadMore() {
    if (loading || currentPage >= pageCount) return;
    loading = true;
    button.classList.add('is-loading');
    button.textContent = 'Loading…';
    try {
      await ensureOrder();
      grid.append(...orderedCards.slice(currentPage * pageSize, (currentPage + 1) * pageSize));
      currentPage++;
      if (currentPage >= pageCount) {
        more.remove();
        observer?.disconnect();
      } else {
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('page', currentPage + 1);
        button.href = nextUrl.href;
      }
    } catch (error) {
      // Preserve the normal navigation link when a network request fails.
      window.location.assign(button.href);
    } finally {
      loading = false;
      button.classList.remove('is-loading');
      button.textContent = buttonLabel;
    }
  }
  button?.addEventListener('click', event => { event.preventDefault(); loadMore(); });
  ensureOrder().then(() => {
    if (button && more.dataset.pagination === 'infinite' && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) loadMore();
      }, { rootMargin: '300px' });
      observer.observe(more);
    }
  }).catch(() => {
    // Server-rendered cards and numbered navigation remain usable offline.
  });
})();
